<i18n lang="yaml">
zh:
  all_templates: "从爆款短篇模版开始你的创作之旅～"
  market_recommend: "市场推荐"
en:
  all_templates: "All Templates"
  market_recommend: "Market Recommend"
</i18n>
<template>

    <!-- 推荐模版 弹窗 -->
    <el-dialog
      class="custom-dialog new-dp-template-dialog mly-template-page-limit-width"
      ref="dialog"
      :width="drawerWidth"
      :top="dialogTop"
      :visible.sync="showDialogRecommendFlag"
      :append-to-body="true"
      :modal-append-to-body="false"
      :close-on-press-escape="true"
      :withHeader="false"
      :destroy-on-close="true"
      :show-close="true"
      :close-on-click-modal="true"
      :wrapperClosable="true"
      @close="close"
      >
      <div style="padding: 0 1rem 1rem 0;position: relative;">
        <el-row :gutter="10" ref="storyTemplate" style="margin-right: 0;">
          <!-- 模板 -->
          <el-col :span="24" style="margin-top: 2rem;">
            <label for="tags" class="model-box-item-title" style="font-size: 22px;">{{$t('all_templates')}}</label>
            <div v-if="$i18n.locale === 'zh'" class="d-flex flex-between"
              style="background: #F5F5FE;border-radius: 20px;color: #366EF4;padding: .25rem 1rem;margin-top: .5rem;position: relative;">
              <div class="d-flex flex-y-center"
                style="line-height: 28px;font-size: 14px;">
                <img src="@/assets/star-yellow.png" style="width: 1rem;height: 1rem;">
                爆款模版，get市场爆款套路最快路径
              </div>
              <div class="d-flex flex-y-center pointer"  @click="$parent.handleGen('genbyzhihu')"
                style="color: rgba(0,0,0,0.4);font-size: 12px;">
                更多模版
                <img src="@/assets/arraw-right.png" style="width: 1rem;height: 1rem;">
              </div>
              <img v-if="!$isMobile()" src="@/assets/mali-template.png" style="width: 68px;height: 78px;position: absolute;top: -60px; right: 80px;">
            </div>
          </el-col>

          <!-- 模板区域 -->
          <el-col :span="24" style="overflow: hidden;">
            <div class="model-box">
                <div v-if="storyTemplates.length > 0" @click.stop="handleTemplateClick(item)" class="model-box-item" :class="{'model-box-item-active': item.id == activeItem.id}" :key="index" v-for="(item,index) in storyTemplates" style="position: relative;">
                  <template>
                    <div v-if="item.recommendFlag" class="market-recommend">{{$t('market_recommend')}}</div>
                    <div class="model-box-item-title">
                      {{item.title}}
                    </div>

                    <el-tooltip placement="top" class="ly-tooltip-class">
                      <div slot="content">
                        <div class="score-box d-flex" style="padding: .5rem  .5rem 0 .5rem;align-items: center;">
                          <div class="score-info d-flex" style="flex-direction: column;margin-right: 1rem;">
                            <div class="score-text" style="font-weight: 400;font-size: 12px;color: #FFFFFF;">
                              {{$t('template_difficulty')}}
                            </div>
                            <div class="score-number" style="font-weight: 600;font-size: 32px;color: rgba(255,255,255,0.9);">
                              {{Number(item.score).toFixed(1)}}
                            </div>
                          </div>
                          <div class="score-star">
                            <div class="model-box-item-score d-flex" style="">
                              <div v-for="number in 5" :key="number" >
                                <img style="width: 16px; height: 16px;" v-if="number <= item.score/2" src="../../assets/star-yellow.png" alt="" />
                                <img style="width: 16px; height: 16px;" v-else-if="number == (item.score/2+0.5)" src="../../assets/star-half.png" alt="" />
                                <img style="width: 16px; height: 16px;" v-else src="../../assets/star-white.png" alt="" />
                              </div>
                            </div>
                            <div class="score-desc" style="font-size: 12px;line-height: 32px;color: #FFFFFF;">
                              {{item.scoreDesc}}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="model-box-item-score d-flex" style="margin: .6rem 0;">
                        <div v-for="number in 5" :key="number" >
                          <img style="width: 16px; height: 16px;" v-if="number <= item.score/2" src="../../assets/star-yellow.png" alt="" />
                          <img style="width: 16px; height: 16px;" v-else-if="number == (item.score/2+0.5)" src="../../assets/star-half.png" alt="" />
                          <img style="width: 16px; height: 16px;" v-else src="../../assets/star-white.png" alt="" />
                        </div>
                      </div>
                    </el-tooltip>


                    <el-tooltip placement="top">
                      <div slot="content" style="">
                        <div style="padding: .5rem;width: 13rem;text-align: justify;line-height: 1.5rem;" class="d-flex">
                          {{item.content}}
                        </div>
                      </div>
                      <div class="model-box-item-content ellipsis4">
                        {{item.content}}
                      </div>
                    </el-tooltip>
                    <div class="model-box-item-tag">
                      <span class="model-box-item-tag-item" :key="indexTag" v-for="(itemTag,indexTag) in item.tag&&item.tag.split(',')">{{itemTag}}</span>
                    </div>
                  </template>
                </div>
                <el-empty  v-if="storyTemplates.length==0" image="https://www.creatimix.com/static/empty.jpg" :description="$t('no_template')" style="margin: 0 auto;background-color: #FFFFFF;">
                  <!-- <p style="margin: 0;color: rgba(0,0,0,0.6);font-size: 14px;">敬请期待!</p> -->
                </el-empty>
            </div>
          </el-col>

          <!-- try other -->

          <el-col :span="24">
            <div style="height: 1rem;"></div>
            <label for="other" class="model-box-item-title" style="font-size: 22px;">试试别的</label>
            <div style="height: 1rem;"></div>
            <div style="font-size: 20px;gap: 1.2rem;" class="d-flex flex-between">
              <div class="template-item" :style="{'font-size': $isMobile()?'12px':''}"  @click="handleGen('chaishu')">拆书学习</div>
              <div class="template-item" :style="{'font-size': $isMobile()?'12px':''}"  @click="handleGen('genbyidea')">超短篇小说</div>
              <div class="template-item" :style="{'font-size': $isMobile()?'12px':''}"  @click="handleGen('genbychangpian')">长篇小说</div>
            </div>
            <div style="height: 1rem;"></div>
          </el-col>

        </el-row>

      </div>
    </el-dialog>
</template>
<script>
import * as StoryCpApi from '@/api/storycp'
import * as StoryTemplateApi from '@/api/storytemplate'
import * as EnumApi from '@/api/enums'
import * as StorySynesthesiaElementApi from '@/api/storysynesthesiaelement'
import * as StoryHotApi from '@/api/storyhot'
import { mapState, mapMutations} from 'vuex'
import * as ArticleApi from '@/api/article'
import { nextTick } from 'vue'
export default {
  name: 'StoryRecommendTemplate',
  props: {
    channel: {
      type: String,
      default: 'workspace_index'
    },
  },
  components: {

  },
  data() {
    return {
      otherIndex: 0,
      activeItem: {id: '-1'},
      synesthesiaElements:[],
      cps:[],
      hots:[],
      storyTemplates:[],
      storyTemplateTags:[],
      tags: [],
      queryForm: {
        name: '',
        templateType: 'GUANFANG',
        enableFlag: true,
        recommendFlag: true,
        tag: '',
        current: '',
        size: 3
      },
      paginations: {
        current: 1, // 当前页
        total: 0, // 总行数
        size: 20, // 每页行数
        // sizes: [20], // 每页行数 调整
        layout: 'total, prev, pager, next' // 翻页属性
      }
    }
  },
  mounted() {
    console.log('mounted');
    this.activeItem =  {id: '-1'}
    this.handleTemplatePage()
  },
  computed: {
    ...mapState(['user', 'story', 'showDialogRecommendFlag', 'enums']),
    drawerWidth() {
      return window.innerWidth <= 768 ? '100%' : '700px';
    },
    dialogTop() {
      return window.innerWidth <= 768 ? "5vh" : '10vh';
    },
  },
  created() {
    console.log('created');
  },
  methods: {
    ...mapMutations(['setStory', 'setShowDialogRecommendFlag', 'setActiveTemplate', 'setShowDialogCdpFlag', 'setShowChangpianDialogFlag']),
    close(){
      this.setShowDialogRecommendFlag(false);
    },
    handleOk(){
      console.log('this.$parent', this.$parent);
      this.$parent.activeItem = this.activeItem
      this.setActiveTemplate(this.activeItem)
      this.$parent.createOrUpdateStroy(4);
      this.story.storyTemplateId = this.activeItem.id
      this.setStory(this.story)
      nextTick(()=>{
        this.close()
      })
    },
    handleTemplateClick(item) {
      this.activeItem = item
      this.handleOk()
    },
    handleTemplatePage(){
      console.log('this.queryForm', this.queryForm);
      this.queryForm.tag = this.tags.join(',')
      // this.queryForm.tags = []
      StoryTemplateApi.page(this.queryForm).then(res => {
        let result = res.data.data;
        this.storyTemplates = result.records;
        if(this.storyTemplates.length > 1){
          if(window.innerWidth <= 768){
            document.documentElement.style.setProperty('--template-rows', '2');
            this.storyTemplates = this.storyTemplates.slice(0, 2);
          }else{
            document.documentElement.style.setProperty('--template-rows', '3');
          }
        }
        //default
        this.storyTemplates.forEach((item,index) => {
          if(this.story.storyTemplateId == item.id){
            this.activeItem = item
            return
          }
        })
        this.paginations.total = Number(result.total)
        this.paginations.current = Number(result.current)
        this.paginations.size = Number(result.size)
      });
    },
    handleGen(cmditem) {
      if (!cmditem) {
        this.$message.error(this.$t('menu_missing_command'))
        return
      }
      this.close()
      const story = { id: '' }
      switch (cmditem) {
        case 'genbyidea': // cdp
          // gen story
          story.articleGenType = 'GEN_BY_IDEA'
          story.articleType = 'TANBI_DOUBLE_BOY'
          this.setStory(story)
          this.$router.push({ path: '/home' })
          this.$nextTick(() => {
            setTimeout(() => { this.setShowDialogCdpFlag(true) }, 300)
          })
          break
        case 'genbyoutline': // duanpian dingzhi
          // gen story
          story.articleGenType = 'GEN_BY_OUTLINE'
          story.articleType = 'FEEL_GOOD'
          story.articleStyle = 'ZHENGWEN'
          story.writingPerspective = 'FIRST_PERSON'
          this.setStory(story)
          this.setShowGenbyoutlineFlag(true)
          break
        case 'genbyzhihu': // dp
          story.articleGenType = 'GEN_BY_ZHIHU'
          story.articleType = 'FEEL_GOOD'
          this.setStory(story)
          this.$router.push({ path: '/workspace/gen' })
          this.$nextTick(() => {
            setTimeout(() => { this.setShowDialogDpFlag(true) }, 300)
          })
          break
        case 'genbyzhihuTempalte': // dp recommend
          story.articleGenType = 'GEN_BY_ZHIHU'
          story.articleType = 'FEEL_GOOD'
          this.setStory(story)
          this.$router.push({ path: '/workspace/gen' })
          this.$nextTick(() => {
            setTimeout(() => { this.setShowDialogRecommendFlag(true) }, 300)
          })
          break
        case 'genbychangpian': // changpian
          story.articleGenType = 'GEN_BY_CHANGPIAN'
          story.articleType = 'CP_YANQING'
          this.setStory(story)
          this.setShowChangpianDialogFlag(true)
          this.$router.push({ path: '/workspace/gencp' })
          break
        case 'chaishu': // chaishu

          this.$router.push({ path: '/bookbreakdown/index' })
          break
      }
    },
    handleCurrentChange(page) {
      // 切换页码
      this.paginations.current = page
      this.handlePage()
    },
    handleSizeChange(size) {
      // 切换size
      this.paginations.size = size
      this.size = size
      this.handlePage()
    }
  },
  beforeDestroy() {

  },
}
</script>

<style scoped lang="scss">
:root {
  --template-rows: 3; /* 默认红色 */
}
$tagMT: .5rem;
.mly-template-page-limit-width {
  // max-width: 768px;
}
/deep/ .el-dialog__header {
  padding: 0;
}
/deep/ .el-dialog__body > div:first-of-type {
  padding: 0 0 .5rem 0 !important;
}

/deep/ .story-idea .el-textarea__inner{
  background: #F4F4F4;
  padding: 1rem;
}
.pagination-fixed {
  position: fixed;
  bottom: 0;
  right: 0;
  margin-bottom: 1rem;
  margin-right: 3rem;
  background: #FAFAFD;
  padding: 1rem 0;
}
.story-idea-tag-box {
  margin-top: $tagMT;
  &-tag {
    display: inline-block;
    background: #F2F3FF;
    border-radius: 12px;
    font-weight: 400;
    font-size: 12px;
    color: #242424;
    padding: .25rem .5rem;
    margin: 0 .5rem .5rem 0;
    white-space: nowrap;
  }
}
.get-more {
  font-size: 12px;
  color: #0052D9;
  white-space: nowrap;
  margin-top: $tagMT;
}
/* 全局滚动条轨道的padding */
.model-box::-webkit-scrollbar-track {
  background-color: transparent;
  margin: 1rem 0;
}
/* 滚动条的样式 */
.model-box::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  margin: 1rem 0;
  background-color: transparent;
}
.model-box::-webkit-scrollbar-thumb {
  background-color: rgba(54,110,244,0.1);
}
/* 滚动条角落（右下角交汇处） */
.model-box::-webkit-scrollbar-corner {
  background-color: transparent; /* 角落透明 */
}
.model-box {
  display: grid;
  max-height: 50vh;
  // grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  // grid-auto-rows: minmax(30px, auto); /* 行的高度至少为100px，但可以更高以适应内容 */
  // grid-auto-flow: row;
  grid-template-columns: repeat(var(--template-rows), 1fr);
  /*  声明了两行，行高分别为 50px 50px  */
  // grid-template-rows:  repeat(var(--template-rows), 1fr);
  gap: .5rem;
  margin-top: 1rem;
  padding-bottom: 1rem;
  overflow-x: auto;
  // overflow-y: hidden;
  white-space: nowrap; /* 确保内容不会换行 */
  box-sizing: border-box; /* 边框计算在宽度内 */

  &-item:hover{
    box-shadow: 0px 4px 8px 0px rgba(0,0,0,0.1);
    background: linear-gradient( 270deg, #F3F4FF 0%, #E8EAFF 100%);
    cursor: pointer;
    // border: 1px solid #366EF4;
  }
  &-item {
    position: relative;
    width: 12rem;
    padding: 1rem;
    box-shadow: 0px 1px 2px 0px rgba(0,0,0,0.1);
    border-radius: 14px;
    box-sizing: border-box; /* 边框计算在宽度内 */
    border: 1px solid #EBEEF5;
    background: #FFFFFF;
    overflow: hidden;
    color: #303133;
    &-title {
      font-weight: 600;
      font-size: 1rem;
      color: rgba(0,0,0,0.9);
    }
    &-notice {
      margin-left: 0.5rem;
      height: 1.5rem;
      background: rgba(255,203,79,0.3);
      border-radius: 3rem;
      color: #985A03;
      font-size: 0.75rem;
      padding: 0 0.7rem;
      line-height: 1.5rem;
      display: inline-flex;
      display: flex;
      align-items: center;
      gap: 0.5rem;
    }
    &-active {
      border: 1px solid #366EF4;
      background: linear-gradient( 270deg, #F3F4FF 0%, #E8EAFF 100%);
    }
    &-content {
      font-size: 12px;
      color: rgba(0,0,0,0.6);
      line-height: 1.25rem;
      text-align: justify;
      // margin-top: 1rem;
      margin-bottom: 2rem;
    }
    &-tag {
      position: absolute;
      left: 0;
      bottom: 0;
      padding: 1rem;
      &-item{
        margin-top: .5rem;
        display: inline-block;
        background: #F2F3FF;
        border-radius: 12px;
        font-weight: 400;
        font-size: 12px;
        color: #366EF4;
        padding: .25rem .5rem;
        margin-right: .5rem;
        white-space: nowrap;
      }
    }
  }
}
.multiline-ellipsis {
  position: relative; /* 为伪元素定位做准备 */
  max-height: 6em; /* 根据内容和行高设置最大高度，这里假设每行2em */
  overflow: hidden; /* 隐藏溢出的内容 */
  line-height: 1.25em; /* 设置行高，与最大高度保持一致 */
  text-align: justify; /* 文本两端对齐 */
  // padding-right: 20px; /* 为省略号留出空间 */
}

.multiline-ellipsis::after {
  content: '...';
  text-align: right;
  position: absolute;
  bottom: 0;
  right: 0;
  color: #FFFFFF;
  padding-left: 40px; /* 渐变背景的长度 */
  background: linear-gradient(to right, transparent, white 50%);
  /* 渐变背景从透明到白色，覆盖超出的文本 */
}
.ellipsis4 {
    display: -webkit-box;
    -webkit-line-clamp: 7;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
}
.custom-select-v1 {
  /deep/ .el-input__inner {
    border-radius: 20px;
    height: 1.75rem;
    line-height: 1.75rem;
    font-size: 12px;
    background: #FFFFFF;
    border: 1px solid #EBEEF5 !important;
  }
  /deep/ .el-input__suffix {
    height: 1.75rem;
    line-height: 1.75rem;
    font-size: 12px;
    display: flex;
    align-items: center;
  }
}
.field-content {
  color: rgba(0,0,0,0.6);
}
.market-recommend {
  width: 80px;
  height: 16px;
  background: linear-gradient( 90deg, #FFCF52 0%, #FF8E16 100%);
  border-radius: 10px 0px 10px 0px;
  text-align: center;
  line-height: 18px;
  font-size: 10px;
  color: #FFFFFF;
  position: absolute;
  top: -2px;
  left: -2px;
}
.template-item {
  flex: 1;
  cursor: pointer;
  padding: 1rem;
  font-weight: 600;
  font-size: 16px;
  color: #242424;
  background: #F5F5FE;
  border-radius: 10px;
  text-align: center;
}
.template-item:hover{
    color: #FFFFFF;
    background: #366EF4;
  }
</style>
